// @flow

import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import Icon from '../../Icon';
import Button from './Button';

const StyledModal = styled(Modal)`
  &.ant-modal {
    display: flex;
    justify-content: center;
  }
  .ant-modal-content {
    border-radius: 0;
    width: ${({ width }) => width};
  }
  .ant-modal-body {
    padding: 30px;
  }
`;

const Title = styled.h3`
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1;
`;

const Close = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  line-height: 1;
  cursor: pointer;

  :hover {
    color: #333;
    transform: rotate(90deg);
    transition: all 0.3s;
  }
`;

const Footer = styled.div`
  margin-top: 20px;
  text-align: center;

  button {
    margin: 0 10px;
  }
`;

type Props = {
  children: any,
  title: string,
  onCancel: Function,
  cancelText: string,
  onOk: Function,
  okText: string,
  footer: any,
  closeable?: boolean,
};

const ModalWrapper = ({
  children,
  title,
  onCancel,
  cancelText,
  onOk,
  okText,
  footer,
  closeable,
  ...others
}: Props) => (
  <StyledModal width="auto" footer={null} {...others} closable={false}>
    {closeable && (
      <Close onClick={e => onCancel && onCancel(e)}>
        <Icon type="close" />
      </Close>
    )}
    {title && <Title>{title}</Title>}
    {children}

    {footer === undefined ? (
      <Footer>
        {/* TODO: Resolve this! $FlowFixMe */}
        <Button type="primary" size="small" width="80px" onClick={e => onOk && onOk(e)}>
          {okText || 'Ok'}
        </Button>
        {/* TODO: Resolve this! $FlowFixMe */}
        <Button width="80px" size="small" onClick={e => onCancel && onCancel(e)}>
          {cancelText || 'Cancel'}
        </Button>
      </Footer>
    ) : (
      footer
    )}
  </StyledModal>
);

ModalWrapper.defaultProps = {
  closeable: true,
};

export default ModalWrapper;
